// Desc: Create a slice for subscription plan
import { createSlice } from "@reduxjs/toolkit";
import {
  activeSubscriptionLoaded,
  activeSubscriptionLoading,
  activeSubscriptionLoadingError,
} from "./subscriptionStateActions";
import { IActiveSubscriptionModel } from "../../../types/types";

export interface ActiveSubscriptionState {
  loading: boolean;
  error: string | null;
  data: IActiveSubscriptionModel | undefined;
}

const initialState: ActiveSubscriptionState = {
  loading: false,
  error: null,
  data: undefined,
};

const activeSubscriptionSlice = createSlice({
  name: "activeSubscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(activeSubscriptionLoading, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(activeSubscriptionLoaded, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(activeSubscriptionLoadingError, (state, action) => {
      state.loading = false;
      state.error = "Failed to fetch user active subscription";
    });
  },
});

export default activeSubscriptionSlice.reducer;
